const items = [
  "0% No-Show Tolerance",
  "Guaranteed Same-Day Pay",
  "100% SIA Licensed",
  "Dual-Sided Ratings",
  "Instant Dispatch",
  "Zero Excuses",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/5 bg-[#0a0d13] py-5">
      <div className="animate-marquee-slow flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-lg font-bold uppercase tracking-wide text-slate-600">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-amber-500/60" />
          </span>
        ))}
      </div>
    </div>
  );
}
